export const PrismaServices = [
  {
    Summary: "Monthly Bookkeeping & Transactions",
    Details: [
      {
        Item: "This is the outsourced service of a normal financial department, where Prisma Accountants capture and reconciles monthly transactions for you. Monthly management accounts can be provided in order to keep you updated at all times. A consultant is assigned to you as client, but there will always be someone who can assist you.",
      },
    ],
  },
  {
    Summary: "Tax Advice & Compliance & Planning",
    Details: [
      {
        Item: "Insuring tax compliance through continuous planning sessions with you as our client, where Prisma Accountants can provide you with the necessary advice and plans going forward in order to obtain optimal results. Our portfolio include the following:",
        Sublist: [
          { Item: "Individual Income Tax" },
          { Item: "Company Tax" },
          { Item: "Provisional Returns" },
          { Item: "Donations Tax" },
          { Item: "Dividend Tax" },
          { Item: "and more." },
        ],
      },
    ],
  },
  {
    Summary: "Payroll services",
    Details: [
      {
        Item: "We provide the monthly calculations and all relevant documentation for your employees, as well as submit the monthly returns to SARS/UIF for payment. Half year and yearly payroll reconciliations are done and submitted to SARS in order to provide them with the necessary statutory employer and employee information.",
      },
    ],
  },
  {
    Summary: "Pastel Accounting / Online Recordkeeping & Training",
    Details: [
      {
        Item: "Online systems is becoming an integral part of business activities, with technology advancing rapidly. We provide the service of updating these systems monthly as well as provide training for this systems.",
      },
    ],
  },
  {
    Summary: "Accounting & Business Planning services",
    Details: [
      {
        Item: "According to law, each company is required to compile yearly financial statements. Prisma Accountants is equipped, as Professional Accountants, to complete and sign off your annual financial statements and this service includes planning sessions as well as discussions regarding the financial statements, either compiled or independently reviewed. Assistance with regard to analysing business results and financing decisions is readily available.",
      },
    ],
  },
  {
    Summary: "Statutory Registrations & New Registrations",
    Details: [
      {
        Item: "SARS and CIPC require continuous updating of records and information in order to ensure compliance. The following secretarial tasks can be completed by Prisma Accountants for you and your business:",
        Sublist: [
          {
            Item: "Company & CC Amendments",
          },
          {
            Item: "Company Registrations",
          },
          {
            Item: "New Memorandum of Incorporation",
          },
          {
            Item: "Deregistration",
          },
          {
            Item: "Disclosure Certificates",
          },
          {
            Item: "Annual Returns",
          },
        ],
      },
    ],
  },
];
